export const PLACEHOLDER_IMAGE = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjNmNGY2Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyMCIgZmlsbD0iIzZiNzI4MCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkltYWdlIG5vdCBhdmFpbGFibGU8L3RleHQ+PC9zdmc+';

export const PROPERTY_IMAGES = {
  placeholder: PLACEHOLDER_IMAGE,
  fallback: {
    villa: 'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg',
    apartment: 'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg',
    penthouse: 'https://images.pexels.com/photos/1571468/pexels-photo-1571468.jpeg',
    modern: 'https://images.pexels.com/photos/1732414/pexels-photo-1732414.jpeg',
    seaside: 'https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg',
    townhouse: 'https://images.pexels.com/photos/1571461/pexels-photo-1571461.jpeg'
  }
}; 